import React, { useState } from 'react';
import { MapPinIcon, ClockIcon, CheckIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
export const Bookings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const bookings = {
    upcoming: [{
      id: '1',
      date: 'Tomorrow, 9:00 AM',
      pickup: 'Home',
      dropoff: 'Office',
      type: 'Standard',
      price: 85,
      currency: 'RM'
    }],
    completed: [{
      id: '1',
      date: 'Yesterday, 7:30 PM',
      pickup: 'Office',
      dropoff: 'Home',
      type: 'Premium',
      price: 120,
      currency: 'SGD',
      status: 'completed'
    }, {
      id: '2',
      date: 'May 28, 8:45 AM',
      pickup: 'Home',
      dropoff: 'Changi Airport',
      type: 'Airport',
      price: 150,
      currency: 'RM',
      status: 'completed'
    }, {
      id: '3',
      date: 'May 25, 6:15 PM',
      pickup: 'Orchard Road',
      dropoff: 'JB Sentral',
      type: 'Standard',
      price: 85,
      currency: 'SGD',
      status: 'completed'
    }]
  };
  return <div className="min-h-screen bg-background pb-16" data-id="element-138">
      <div className="p-6" data-id="element-139">
        <h1 className="text-xl font-semibold mb-6" data-id="element-140">My Bookings</h1>
        <div className="flex mb-6 bg-card rounded-lg p-1" data-id="element-141">
          <button className={`flex-1 py-2 rounded-md text-center ${activeTab === 'upcoming' ? 'bg-primary text-background' : ''}`} onClick={() => setActiveTab('upcoming')} data-id="element-142">
            Upcoming
          </button>
          <button className={`flex-1 py-2 rounded-md text-center ${activeTab === 'completed' ? 'bg-primary text-background' : ''}`} onClick={() => setActiveTab('completed')} data-id="element-143">
            Completed
          </button>
        </div>
        <div className="space-y-4" data-id="element-144">
          {bookings[activeTab as keyof typeof bookings].length === 0 ? <div className="text-center py-12" data-id="element-145">
              <p className="text-white text-opacity-70" data-id="element-146">
                No {activeTab} bookings found
              </p>
            </div> : bookings[activeTab as keyof typeof bookings].map(booking => <div key={booking.id} className="card" data-id="element-147">
                <div className="flex justify-between items-start mb-3" data-id="element-148">
                  <div className="flex items-center" data-id="element-149">
                    <ClockIcon size={16} className="text-primary mr-2" data-id="element-150" />
                    <span className="text-sm" data-id="element-151">{booking.date}</span>
                  </div>
                  <div className="chip" data-id="element-152">
                    {booking.currency} {booking.price}
                  </div>
                </div>
                <div className="flex items-start mb-3" data-id="element-153">
                  <MapPinIcon size={18} className="text-primary mt-1 mr-2" data-id="element-154" />
                  <div data-id="element-155">
                    <p className="text-sm text-white text-opacity-70" data-id="element-156">From</p>
                    <p className="font-medium" data-id="element-157">{booking.pickup}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3" data-id="element-158">
                  <MapPinIcon size={18} className="text-primary mt-1 mr-2" data-id="element-159" />
                  <div data-id="element-160">
                    <p className="text-sm text-white text-opacity-70" data-id="element-161">To</p>
                    <p className="font-medium" data-id="element-162">{booking.dropoff}</p>
                  </div>
                </div>
                <div className="flex justify-between items-center" data-id="element-163">
                  <span className="text-sm text-white text-opacity-70" data-id="element-164">
                    {booking.type}
                  </span>
                  {activeTab === 'upcoming' ? <button className="text-primary text-sm font-medium" data-id="element-165">
                      Cancel Booking
                    </button> : <div className="flex items-center text-green-500" data-id="element-166">
                      <CheckIcon size={16} className="mr-1" data-id="element-167" />
                      <span className="text-sm font-medium" data-id="element-168">Completed</span>
                    </div>}
                </div>
              </div>)}
        </div>
      </div>
      <BottomNav data-id="element-169" />
    </div>;
};